export default function handleTermsTabs() {
  const tabsButton = document.querySelectorAll('[data-tab]');
  const tabsContent = document.querySelectorAll('[data-tab-content]');

  tabsContent.length > 0 &&
    tabsButton.length > 0 &&
    tabsButton.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();

        tabsButton.forEach((el) => {
          el.classList.remove('active');
        });
        button.classList.add('active');

        const tabContentId = button.getAttribute('href').replace('#', '');
        tabsContent.forEach((content) => {
          content.id == tabContentId ? content.classList.add('active') : content.classList.remove('active');
        });

        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 20);
      });

      if (location.hash != null && location.hash != '') {
        const tabContentId = location.hash.replace('#', '');
        tabsContent.forEach((content) => {
          content.id == tabContentId ? content.classList.add('active') : content.classList.remove('active');
        });

        tabsButton.forEach((button) => {
          if (button.getAttribute('href').replace('#', '') == tabContentId) {
            button.classList.add('active');

            setTimeout(() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }, 20);

            if (window.innerWidth < 1050) {
              const sidePositioning = button.offsetLeft - window.innerWidth / 2 + button.offsetWidth / 2;
              button.offsetParent.scrollTo({ left: sidePositioning, behavior: 'smooth' });
            }
          } else {
            button.classList.remove('active');
          }
        });
      }
    });
}
